export default __webpack_public_path__ + "static/media/pic1.0c0d2e80.png";